<template>
    <div class="supportMains">
        <div class="header">
            <a-row >
                <a-form-item class="genericFrom" aria-required="true">
                    <b>{{$t('support.project')}}<span style="color: red">*</span></b>
                    <a-select size="small" style="width: 300px" @change="projectChange">
                        <a-select-option v-for="item in projects" :value="item.key+'|'+item.org_code">{{item.value}}</a-select-option>
                    </a-select>
                </a-form-item>
            </a-row>
        </div>
        <div class="support">
            <a-tabs defaultActiveKey="0" tabPosition="left" ref="tabs">
                <!--                <a-tab-pane tab="A01/Reopen ASN" key="8" v-if="A01ReopenASN" ><a01ReopenASN :orgId="orgId" :projectId="projectId" :url="url"></a01ReopenASN></a-tab-pane>-->
                <!--                <a-tab-pane tab="C01/Move PO# to warehouse" key="9" v-if="C01MovePOToWarehouse"><c01MovePOToWarehouse :orgId="orgId" :projectId="projectId" :url="url"></c01MovePOToWarehouse></a-tab-pane>-->
                <a-tab-pane v-for="(item,index) in supportList" :key="item.uid" :tab="item.support_name">
                    <div class="supportMains">
                        <div class="buttonDiv">
                            <a-button size="small" class="submitBtn" @click="submit(supportList[index].support_type,supportList[index].procedure_name)">{{$t('support.submit')}}</a-button>
                            <a-button size="small" class="submitBtn" @click="reset(supportList[index].support_type)">{{$t('support.reset')}}</a-button>
                        </div>
                        <a-form :form="form">
                            <a-col class="supportColumns">
                                <a-row>
                                    <a-form-item  class="genericFrom" >
                                        <div v-if="supportList[index].support_name == list[i].supportName" v-for="(v,i) in list" style="float:left;width: 50%;">
                                            <div v-if="list[i].visible">
                                                <div style="float:left;width: 100px;font-weight: bold" v-text="list[i].parameter_name"/>
                                                <a-input size="small" :ref="'ref'+supportList[index].support_type+list[i].parameter_id" v-model="list[i].default_value" style="width: 300px" v-if="list[i].text" />
                                                <a-input-number size="small" :ref="'ref'+supportList[index].support_type+list[i].parameter_id" v-model="list[i].default_value" style="width: 300px" v-if="list[i].number" precision="3"/>
                                                <a-date-picker size="small" :ref="'ref'+supportList[index].support_type+list[i].parameter_id" format="YYYY-MM-DD HH:mm:ss" v-model="list[i].default_value" v-if="list[i].date" style="width: 300px" show-time/>
                                                <a-select size="small" :ref="'ref'+supportList[index].support_type+list[i].parameter_id" style="width: 300px" v-if="list[i].select" v-model="list[i].default_value" >
                                                    <a-select-option v-for="(selectOptionsItem,j) in selectOptions" v-if="selectOptionsItem.selectOptionName == supportList[index].support_type+list[i].parameter_id" :value="selectOptionsItem.key">{{selectOptionsItem.value}}</a-select-option>
                                                </a-select>
                                            </div>
                                        </div>
                                    </a-form-item>
                                </a-row>
                                <a-row class="noteColumns">
                                    <b>{{$t('support.note')}}</b>
                                    <div>
                                        <a-textarea disabled :ref="'ref'+supportList[index].support_type+'Note'" class="noteText" style="color: black;height: 200px"/>
                                    </div>
                                </a-row>
                            </a-col>
                        </a-form>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
        <!--        <div class="m-form__group form-group row">-->
        <!--            <label class="col-lg-4 col-form-label">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>-->
        <!--            <div class="col-lg-4" v-on:click="addNode()">-->
        <!--                <div data-repeater-create="" style="text-align: center"-->
        <!--                     class="btn btn btn-sm btn-brand m-btn m-btn&#45;&#45;icon m-btn&#45;&#45;pill m-btn&#45;&#45;wide">-->
        <!--            <span>-->
        <!--                <span> 添加 </span>-->
        <!--            </span>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>
<script>
    import a01ReopenASN from './support/A01ReopenASN.vue'
    import c01MovePOToWarehouse from './support/C01MovePOToWarehouse.vue'
    import ajax from "../../api/ajax";
    import api from "../../api/url";

    export default{
        components:{
            a01ReopenASN,
            c01MovePOToWarehouse,
        },
        data(){
            return{
                form: this.$form.createForm(this, {}),
                orgs:[],
                projects:[],
                panes:[{
                    key:"1",
                    name:"A01/Reopen ASN test",
                    tabName:a01ReopenASN,
                },{
                    key:"8",
                    name:"C01/Move PO# to warehouse",
                    tabName:c01MovePOToWarehouse,
                }],
                orgId:'',
                projectId:'',
                url:'',
                supportList:{},
                supportDetailList:{},
                A01ReopenASN:false,
                C01MovePOToWarehouse:false,
                note:"",
                //类型数组
                list:[
                    {
                        supportName:"",
                        parameter_id:"",
                        parameter_name:"",
                        visible:false,
                        text:false,
                        number:false,
                        select:false,
                        date:false,
                        default_value:""
                    }
                ],
                //所有下拉数据集合
                selectOptions:[{selectOptionName:"",key:"",value:""}],
            }
        },
        created(){
            this.init()
        },
        methods:{
            init(){
                //获取org
                // ajax.get(api.SUPPORTGETORGS).then(res=>{
                //     this.orgs = res.data
                // });
                //获取project
                ajax.get(api.SUPPORTGETPROJECTSALL).then(res=>{
                    this.projects = res.data;
                    this.orgId = res.data[0].org_code;
                });
                //获取supportHeaderList
                // this.getSupportHeaderList();

                // this.$nextTick(function () {
                //     this.$refs.tabs.$children[0].$el.style.display = 'block';
                // });
                // this.$nextTick(function () {
                //     this.$refs.tabs.$children[0].$refs.tabs[1].style.display = 'none';
                // });
            },
            orgChange(val){
                this.orgId = val;
                let paramsLog = {
                    orgCode: val,
                }
                ajax.get(api.SUPPORTGETPROJECTS,paramsLog).then(res=>{
                    this.projects = res.data
                })
            },
            projectChange(val){
                this.projectId = val.split("|")[0];
                this.orgId = val.split("|")[1];
                let paramsLog = {
                    orgCode:this.orgId,
                    projectCode: this.projectId,
                }
                ajax.get(api.SUPPORTGETPROJECTUrl,paramsLog).then(res=>{
                    this.url = res.data[0].value
                })
                this.A01ReopenASN=true;
                this.C01MovePOToWarehouse=true;
                //获取supportHeaderList
                this.getSupportHeaderList();
            },
            getSupportHeaderList(){
                this.list = [
                    {
                        supportName:"",
                        parameter_id:"",
                        parameter_name:"",
                        visible:false,
                        text:false,
                        number:false,
                        select:false,
                        date:false,
                        default_value:""
                    }
                ];
                this.selectOptions = [{selectOptionName:"",key:"",value:""}];
                //获取supportHeaderList
                let paramsLog = {
                    orgCode: this.orgId,
                    projectCode: this.projectId,
                };
                ajax.get(api.GETSUPPORTHEADERLIST,paramsLog).then(res=>{
                    this.supportList = res.data;
                    if(this.supportList.length>0){
                        for(let i in this.supportList){
                            // if(i==0){
                            //     this.list.push({supportName:this.supportList[i].support_name,inputType:false,selectType:true});
                            // }else{
                            //     this.list.push({supportName:this.supportList[i].support_name,inputType:true,selectType:false});
                            // }
                            //获取supportDetailList
                            let paramsLog = {
                                headerUid:this.supportList[i].uid,
                            }
                            ajax.get(api.GETSUPPORTDETAILLIST,paramsLog).then(ress=>{
                                this.supportDetailList = ress.data;
                                if(this.supportDetailList.length>0){
                                    for(let j in this.supportDetailList){
                                        let isText = false;
                                        let isNumber = false;
                                        let isSelect = false;
                                        let isDate = false;
                                        let isVisible = false;
                                        let selectOption = "";
                                        let selectOptionArr = [];
                                        if("TEXT"==this.supportDetailList[j].data_type){
                                            isText = true;
                                        }else if(this.supportDetailList[j].data_type.indexOf("DECIMAL")>-1){
                                            isNumber = true;
                                        }else if(this.supportDetailList[j].data_type.indexOf("DROPDOWN")>-1){
                                            isSelect = true;
                                            selectOption = this.supportDetailList[j].data_type.substring(this.supportDetailList[j].data_type.indexOf("{")+1,this.supportDetailList[j].data_type.indexOf("}"));
                                            selectOptionArr = selectOption.split(",")
                                            if(selectOptionArr.length>0){
                                                for (let k in selectOptionArr){
                                                    let optionKey = "";
                                                    let optionValue = "";
                                                    if(selectOptionArr[k].split(":").length>1){
                                                        optionKey = selectOptionArr[k].split(":")[0];
                                                        optionValue = selectOptionArr[k].split(":")[1];
                                                    }else{
                                                        optionKey = selectOptionArr[k];
                                                        optionValue = selectOptionArr[k];
                                                    }
                                                    this.selectOptions.push({selectOptionName:this.supportList[i].support_type+this.supportDetailList[j].parameter_id,key:optionKey,value:optionValue});
                                                }
                                            }
                                        }else if("DATE"==this.supportDetailList[j].data_type){
                                            isDate = true;
                                        }
                                        if("Y"==this.supportDetailList[j].visible){
                                            isVisible = true;
                                        }
                                        this.list.push({supportName:this.supportList[i].support_name,parameter_id:this.supportDetailList[j].parameter_id,parameter_name:this.supportDetailList[j].parameter_name,
                                            visible:isVisible,text:isText,number:isNumber,select:isSelect,date:isDate,default_value:this.supportDetailList[j].default_value,
                                            selectOptions:[this.selectOptions]
                                        });
                                        console.log(JSON.stringify(this.list));
                                    }
                                }
                            });
                        }
                    }
                });
            },
            submit(support_type,procedure_name){
                var params = {};
                params.procedureName = procedure_name;
                params.supportType = support_type;
                params.orgCode = this.orgId;
                params.projectCode = this.projectId;
                if(null!=this.$refs["ref"+support_type+"1"]){
                    params.parameter1 = this.$refs["ref"+support_type+"1"][0].value;
                }
                if(null!=this.$refs["ref"+support_type+"2"]){
                    params.parameter2 = this.$refs["ref"+support_type+"2"][0].value;
                }
                if(null!=this.$refs["ref"+support_type+"3"]){
                    params.parameter3 = this.$refs["ref"+support_type+"3"][0].value;
                }
                if(null!=this.$refs["ref"+support_type+"4"]){
                    params.parameter4 = this.$refs["ref"+support_type+"4"][0].value;
                }
                if(null!=this.$refs["ref"+support_type+"5"]){
                    params.parameter5 = this.$refs["ref"+support_type+"5"][0].value;
                }
                if(null!=this.$refs["ref"+support_type+"6"]){
                    params.parameter6 = this.$refs["ref"+support_type+"6"][0].value;
                }
                if(null!=this.$refs["ref"+support_type+"7"]){
                    params.parameter7 = this.$refs["ref"+support_type+"7"][0].value;
                }
                if(null!=this.$refs["ref"+support_type+"8"]){
                    params.parameter8 = this.$refs["ref"+support_type+"8"][0].value;
                }
                if(null!=this.$refs["ref"+support_type+"9"]){
                    params.parameter9 = this.$refs["ref"+support_type+"9"][0].value;
                }
                if(null!=this.$refs["ref"+support_type+"10"]){
                    params.parameter10 = this.$refs["ref"+support_type+"10"][0].value;
                }
                params.url = this.url;//http://172.16.100.183:8099/TEST_SHAB2B_WMS/SupportServlet
                ajax.get(api.SENDSUPPORT,params).then(res=>{
                    if(res.msg.indexOf("Operation Success") > -1 ){
                        this.$refs["ref"+support_type+"Note"][0].value=res.msg;
                        this.saveLog(support_type,params,"true","Succeed");
                    }else{
                        this.saveLog(support_type,params,"false",res.msg);
                        this.$refs["ref"+support_type+"Note"][0].value=res.msg;
                    }
                })
            },
            saveLog(support_type,params,isSuccess,msg){
                let paramsLog = {
                    supportType: support_type,
                    params: JSON.stringify(params),
                    isSuccess: isSuccess,
                    returnMsg:msg
                }
                ajax.get(api.SUPPORTSAVELOG,paramsLog).then(res=>{
                    if(res.code == 200){
                        // this.resetCon(support_type);
                        this.getSupportHeaderList();
                    }else{
                        this.$refs["ref"+support_type+"Note"][0].value=this.$refs["ref"+support_type+"Note"][0].value+"\n"+res.msg;
                    }
                })
            },
            reset(support_type){
                //获取supportHeaderList
                this.getSupportHeaderList();
                // this.resetCon(support_type);
                this.$refs["ref"+support_type+"Note"][0].value="";
            },
            resetCon(support_type){
                if(null!=this.$refs["ref"+support_type+"1"]){
                    this.$refs["ref"+support_type+"1"][0].value="";
                }
                if(null!=this.$refs["ref"+support_type+"2"]){
                    this.$refs["ref"+support_type+"2"][0].value="";
                }
                if(null!=this.$refs["ref"+support_type+"3"]){
                    this.$refs["ref"+support_type+"3"][0].value="";
                }
                if(null!=this.$refs["ref"+support_type+"4"]){
                    this.$refs["ref"+support_type+"4"][0].value="";
                }
                if(null!=this.$refs["ref"+support_type+"5"]){
                    this.$refs["ref"+support_type+"5"][0].value="";
                }
                if(null!=this.$refs["ref"+support_type+"6"]){
                    this.$refs["ref"+support_type+"6"][0].value="";
                }
                if(null!=this.$refs["ref"+support_type+"7"]){
                    this.$refs["ref"+support_type+"7"][0].value="";
                }
                if(null!=this.$refs["ref"+support_type+"8"]){
                    this.$refs["ref"+support_type+"8"][0].value="";
                }
                if(null!=this.$refs["ref"+support_type+"9"]){
                    this.$refs["ref"+support_type+"9"][0].value="";
                }
                if(null!=this.$refs["ref"+support_type+"10"]){
                    this.$refs["ref"+support_type+"10"][0].value="";
                }
            },
        }
    }
</script>
<style>
    .supportMains{
        height: 100%;
        width: 100%;
        background-color: white;
        text-align-last: left;
    }
    .header{
        height: 50px;
        width: 100%;
        background-color: white;
        /*text-align:center;*/
        /*line-height:50px;*/
        padding-top: 8px;
        padding-left: 50px;
        border: 1px solid #e8eaec;
        border-radius: 5px;
        float: left;
    }
    .support{
        height:50%;
        width: 100%;
        float: left;
        /*margin-top: 10px;*/
        background-color: white;
    }
    .buttonDiv{
        margin: 5px 0px 20px 0px;
    }
    .supportColumns{
        width: 100%;
        height: 100%;
        float: left;
    }
    .noteColumns{
        margin-top: 50px;
    }
    .submitBtn{
        width: 60px;
        height: 25px;
        font-weight: bolder;
        background-color: #2B9ED6;
        margin-left: 5px;
    }
    .noteText{
        width: 90%;
    }
</style>